import React from "react";

const process = [
  { title: "Think", description: "Understand the problem before writing code." },
  { title: "Design", description: "Plan the architecture and user experience." },
  { title: "Build", description: "Ship clean, tested, production-ready code." },
  { title: "Deploy", description: "Launch, monitor, and iterate with real users." },
];

const About = () => {
  return (
    <section className="section" id="about">
      <div className="section-inner">
        <div className="section-head reveal">
          <div className="eyebrow">About Me</div>
          <h2 className="section-title">The person behind the code</h2>
        </div>

        <div className="about-grid">
          <div className="about-text reveal">
            <p>
              I'm a Full-Stack Software Engineer with 6+ years of experience
              delivering production mobile and web applications. I specialize
              in Flutter, React, Node.js, and cloud infrastructure (AWS,
              Firebase).
            </p>
            <p>
              I recently completed my{" "}
              <strong>MSc in Data Science (with Commendation)</strong> at the
              University of Aberdeen, adding machine learning and data
              analysis to my toolkit. I'm currently based in Aberdeen and
              actively seeking software engineering opportunities.
            </p>
            <p>
              What sets me apart: I don't just write code, I ship products. My
              apps have real users, process real transactions, and solve real
              problems.
            </p>

            <div className="process-strip">
              {process.map((step, index) => (
                <div className="process-step" key={step.title}>
                  <div className="process-step-num">0{index + 1}</div>
                  <h4>{step.title}</h4>
                  <p>{step.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="about-highlights reveal">
            <div className="highlight-card">
              <strong>🎓 MSc Data Science</strong>
              <span>University of Aberdeen (Commendation)</span>
            </div>
            <div className="highlight-card">
              <strong>📱 3 Live Apps</strong>
              <span>App Store &amp; Play Store</span>
            </div>
            <div className="highlight-card">
              <strong>👥 2000+ Users</strong>
              <span>Across production applications</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
